function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("metadata", {
  id: "metadata4834"
}, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
  rdfAbout: ""
}, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
  rdfResource: "http://purl.org/dc/dcmitype/StillImage"
}), /*#__PURE__*/React.createElement("dcTitle", null))));

var _ref3 = /*#__PURE__*/React.createElement("sodipodiNamedview", {
  pagecolor: "#ffffff",
  bordercolor: "#666666",
  borderopacity: 1,
  objecttolerance: 10,
  gridtolerance: 10,
  guidetolerance: 10,
  inkscapePageopacity: 0,
  inkscapePageshadow: 2,
  "inkscapeWindow-width": 2560,
  "inkscapeWindow-height": 968,
  id: "namedview4832",
  showgrid: "false",
  inkscapeZoom: 0.74810606,
  inkscapeCx: 406.05569,
  inkscapeCy: -183.73409,
  "inkscapeWindow-x": 1366,
  "inkscapeWindow-y": 27,
  "inkscapeWindow-maximized": 1,
  "inkscapeCurrent-layer": "surface1"
});

var _ref4 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1"
}, /*#__PURE__*/React.createElement("path", {
  d: "m 217,343 h 175 v 53 H 217 Z m 0,0",
  id: "path4327",
  "inkscapeConnector-curvature": 0
}));

var _ref5 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clip2"
}, /*#__PURE__*/React.createElement("path", {
  d: "m 335.64062,388.92187 c -1.21484,0.8086 -3.03515,1.41797 -5.25781,1.41797 -3.4375,0 -6.67187,-0.40625 -9.91015,-1.41797 -0.8086,-0.20312 -1.41407,-0.40234 -1.82032,-0.40234 -0.60547,0 -0.80859,0.40234 -0.80859,1.21094 v 2.02344 c 0,0.60546 0.20312,1.01171 0.40625,1.41406 0.20312,0.20312 0.60547,0.60937 1.21484,0.80859 3.23438,1.41797 6.875,2.02344 10.91797,2.02344 4.2461,0 7.48047,-1.01172 10.10938,-3.03125 2.6289,-2.02344 3.84375,-4.65234 3.84375,-8.08984 0,-2.42579 -0.60938,-4.2461 -1.82032,-5.86329 -1.21484,-1.41796 -3.23828,-2.83203 -6.0664,-3.84375 l -5.66406,-2.22265 c -2.22266,-0.8086 -3.83985,-1.6211 -4.44532,-2.42969 -0.8125,-0.80859 -1.21484,-1.61719 -1.21484,-3.03125 0,-3.03516 2.22266,-4.65234 6.875,-4.65234 2.62891,0 5.25781,0.40625 7.68359,1.21484 0.8086,0.20313 1.41407,0.40234 1.61719,0.40234 0.60547,0 1.01172,-0.40234 1.01172,-1.21093 v -2.02344 c 0,-0.60547 -0.20313,-1.00781 -0.40625,-1.41406 -0.19922,-0.40625 -0.60547,-0.60547 -1.21094,-0.8086 -3.03515,-1.01172 -6.0664,-1.61718 -9.10156,-1.61718 -3.83984,0 -7.07422,1.01171 -9.50391,2.83203 -2.42578,1.8164 -3.63672,4.44531 -3.63672,7.48047 0,4.64843 2.625,8.08593 7.88672,10.10937 l 6.0625,2.22266 c 2.02344,0.8125 3.23828,1.41797 4.04688,2.22656 0.80859,0.80859 1.01172,1.61719 1.01172,2.82812 0,1.6211 -0.60938,3.03516 -1.82032,3.84375 z m 21.63672,-44.28515 c -0.80859,-0.8086 -2.02343,-1.21094 -3.4375,-1.21094 -1.41797,0 -2.42968,0.40234 -3.23828,1.21094 -0.80469,0.8125 -1.21094,1.82031 -1.21094,3.03515 0,1.21485 0.40625,2.42579 1.21094,3.03125 0.8086,0.8125 1.82031,1.21485 3.23828,1.21485 1.41407,0 2.42578,-0.40235 3.23438,-1.21485 0.80859,-0.80859 1.21484,-1.8164 1.21484,-3.03125 0,-1.21484 -0.20312,-2.42578 -1.01172,-3.03515 z m -1.21484,13.7539 h -4.24609 c -1.01172,0 -1.41407,0.40235 -1.41407,1.41407 v 33.5664 c 0,1.01172 0.40235,1.41407 1.41407,1.41407 h 4.24609 c 1.01172,0 1.41406,-0.40235 1.41406,-1.41407 v -33.5664 c 0,-0.8086 -0.40234,-1.41407 -1.41406,-1.41407 z m 19.00781,8.08594 c 1.82031,-2.02344 4.65235,-3.03125 8.69531,-3.03125 2.02344,0 4.04297,0.19922 5.86329,0.8086 0.60937,0.19921 0.80859,0.19921 1.21484,0.19921 0.60547,0 1.01172,-0.40234 1.01172,-1.41406 v -2.01953 c 0,-0.60937 -0.20313,-1.21484 -0.40625,-1.41797 -0.20313,-0.20312 -0.60547,-0.60547 -1.01172,-0.80859 -2.62891,-0.60547 -5.25781,-1.21485 -7.68359,-1.21485 -5.66016,0 -9.90625,1.6211 -13.14454,5.0586 -3.03125,3.23437 -4.64843,8.08594 -4.64843,14.15234 0,6.06641 1.41406,10.71875 4.44922,13.95313 3.03125,3.23437 7.27734,4.85156 12.9414,4.85156 3.03125,0 5.86328,-0.40234 8.08594,-1.41406 0.60937,-0.20313 1.01172,-0.40235 1.21484,-0.8086 0.20313,-0.20312 0.20313,-0.80859 0.20313,-1.41406 v -2.02344 c 0,-1.01172 -0.40625,-1.41406 -1.01172,-1.41406 -0.20313,0 -0.60547,0 -1.01172,0.19922 -2.22266,0.60937 -4.44922,1.01172 -6.47266,1.01172 -3.83984,0 -6.67187,-1.01172 -8.49218,-3.03125 -1.81641,-2.02344 -2.62891,-5.25781 -2.62891,-9.50391 v -1.01172 c 0.20313,-4.44922 1.01172,-7.68359 2.83203,-9.70703 z m -109.59765,28.3086 h 4.24609 c 1.01172,0 1.41406,-0.40235 1.41406,-1.41407 v -25.27734 c 0,-3.4375 -0.80859,-6.06641 -2.6289,-7.88281 -1.81641,-1.82032 -4.2461,-2.83203 -7.6836,-2.83203 -4.64844,0 -9.5039,1.61718 -14.15234,5.05468 -1.61719,-3.4375 -4.65235,-5.05468 -9.10156,-5.05468 -4.44922,0 -8.89454,1.61718 -13.34375,4.64843 l -0.40625,-2.22265 c 0,-0.60547 -0.20313,-0.8086 -0.60547,-1.01172 -0.20313,-0.20313 -0.60547,-0.20313 -1.01172,-0.20313 h -3.23438 c -1.01172,0 -1.41797,0.40625 -1.41797,1.41797 v 33.56641 c 0,1.01172 0.40625,1.41406 1.41797,1.41406 h 4.2461 c 1.01172,0 1.41406,-0.40234 1.41406,-1.41406 v -27.30078 c 3.4375,-2.01953 6.875,-3.23438 10.51562,-3.23438 2.02344,0 3.4375,0.60547 4.2461,1.82031 0.80859,1.21485 1.41797,2.83204 1.41797,5.25782 v 23.2539 c 0,1.01172 0.40234,1.41407 1.41406,1.41407 h 4.24609 c 1.01172,0 1.41407,-0.40235 1.41407,-1.41407 v -26.08593 c 0,-0.40235 0,-0.8086 0,-1.01172 3.64062,-2.22266 7.07812,-3.23438 10.51562,-3.23438 2.02344,0 3.4375,0.60547 4.24609,1.82031 0.8086,1.21485 1.41797,2.83204 1.41797,5.25782 v 23.2539 c 0,1.01172 0.40235,1.41407 1.41407,1.41407 z m 38.42187,-34.98047 v 26.89453 c -3.44141,2.22265 -6.87891,3.4375 -10.31641,3.4375 -2.22265,0 -3.83984,-0.60938 -4.85156,-1.82031 -1.01172,-1.21485 -1.41406,-3.03516 -1.41406,-5.66407 v -22.84765 c 0,-1.01172 -0.40625,-1.41407 -1.41797,-1.41407 h -4.24609 c -1.01172,0 -1.41407,0.40235 -1.41407,1.41407 v 25.07422 c 0,3.4375 0.8086,6.26953 2.62891,8.08984 1.82031,1.81641 4.44922,2.82812 7.88672,2.82812 4.64844,0 9.30078,-1.61718 13.75,-4.85156 l 0.40234,2.42578 c 0,0.60547 0.20313,0.8086 0.60938,1.01172 0.20312,0.20313 0.60547,0.20313 1.21094,0.20313 h 3.03515 c 1.01172,0 1.41406,-0.40625 1.41406,-1.41797 v -33.36328 c 0,-1.01172 -0.40234,-1.41407 -1.41406,-1.41407 h -4.24609 c -1.21485,0 -1.61719,0.60547 -1.61719,1.41407 z m 0,0",
  id: "path4330",
  "inkscapeConnector-curvature": 0
}));

var _ref6 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clip3"
}, /*#__PURE__*/React.createElement("path", {
  d: "m 335.64062,388.92187 c -1.21484,0.8086 -3.03515,1.41797 -5.25781,1.41797 -3.4375,0 -6.67187,-0.40625 -9.91015,-1.41797 -0.8086,-0.20312 -1.41407,-0.40234 -1.82032,-0.40234 -0.60547,0 -0.80859,0.40234 -0.80859,1.21094 v 2.02344 c 0,0.60546 0.20312,1.01171 0.40625,1.41406 0.20312,0.20312 0.60547,0.60937 1.21484,0.80859 3.23438,1.41797 6.875,2.02344 10.91797,2.02344 4.2461,0 7.48047,-1.01172 10.10938,-3.03125 2.6289,-2.02344 3.84375,-4.65234 3.84375,-8.08984 0,-2.42579 -0.60938,-4.2461 -1.82032,-5.86329 -1.21484,-1.41796 -3.23828,-2.83203 -6.0664,-3.84375 l -5.66406,-2.22265 c -2.22266,-0.8086 -3.83985,-1.6211 -4.44532,-2.42969 -0.8125,-0.80859 -1.21484,-1.61719 -1.21484,-3.03125 0,-3.03516 2.22266,-4.65234 6.875,-4.65234 2.62891,0 5.25781,0.40625 7.68359,1.21484 0.8086,0.20313 1.41407,0.40234 1.61719,0.40234 0.60547,0 1.01172,-0.40234 1.01172,-1.21093 v -2.02344 c 0,-0.60547 -0.20313,-1.00781 -0.40625,-1.41406 -0.19922,-0.40625 -0.60547,-0.60547 -1.21094,-0.8086 -3.03515,-1.01172 -6.0664,-1.61718 -9.10156,-1.61718 -3.83984,0 -7.07422,1.01171 -9.50391,2.83203 -2.42578,1.8164 -3.63672,4.44531 -3.63672,7.48047 0,4.64843 2.625,8.08593 7.88672,10.10937 l 6.0625,2.22266 c 2.02344,0.8125 3.23828,1.41797 4.04688,2.22656 0.80859,0.80859 1.01172,1.61719 1.01172,2.82812 0,1.6211 -0.60938,3.03516 -1.82032,3.84375 z m 21.63672,-44.28515 c -0.80859,-0.8086 -2.02343,-1.21094 -3.4375,-1.21094 -1.41797,0 -2.42968,0.40234 -3.23828,1.21094 -0.80469,0.8125 -1.21094,1.82031 -1.21094,3.03515 0,1.21485 0.40625,2.42579 1.21094,3.03125 0.8086,0.8125 1.82031,1.21485 3.23828,1.21485 1.41407,0 2.42578,-0.40235 3.23438,-1.21485 0.80859,-0.80859 1.21484,-1.8164 1.21484,-3.03125 0,-1.21484 -0.20312,-2.42578 -1.01172,-3.03515 z m -1.21484,13.7539 h -4.24609 c -1.01172,0 -1.41407,0.40235 -1.41407,1.41407 v 33.5664 c 0,1.01172 0.40235,1.41407 1.41407,1.41407 h 4.24609 c 1.01172,0 1.41406,-0.40235 1.41406,-1.41407 v -33.5664 c 0,-0.8086 -0.40234,-1.41407 -1.41406,-1.41407 z m 19.00781,8.08594 c 1.82031,-2.02344 4.65235,-3.03125 8.69531,-3.03125 2.02344,0 4.04297,0.19922 5.86329,0.8086 0.60937,0.19921 0.80859,0.19921 1.21484,0.19921 0.60547,0 1.01172,-0.40234 1.01172,-1.41406 v -2.01953 c 0,-0.60937 -0.20313,-1.21484 -0.40625,-1.41797 -0.20313,-0.20312 -0.60547,-0.60547 -1.01172,-0.80859 -2.62891,-0.60547 -5.25781,-1.21485 -7.68359,-1.21485 -5.66016,0 -9.90625,1.6211 -13.14454,5.0586 -3.03125,3.23437 -4.64843,8.08594 -4.64843,14.15234 0,6.06641 1.41406,10.71875 4.44922,13.95313 3.03125,3.23437 7.27734,4.85156 12.9414,4.85156 3.03125,0 5.86328,-0.40234 8.08594,-1.41406 0.60937,-0.20313 1.01172,-0.40235 1.21484,-0.8086 0.20313,-0.20312 0.20313,-0.80859 0.20313,-1.41406 v -2.02344 c 0,-1.01172 -0.40625,-1.41406 -1.01172,-1.41406 -0.20313,0 -0.60547,0 -1.01172,0.19922 -2.22266,0.60937 -4.44922,1.01172 -6.47266,1.01172 -3.83984,0 -6.67187,-1.01172 -8.49218,-3.03125 -1.81641,-2.02344 -2.62891,-5.25781 -2.62891,-9.50391 v -1.01172 c 0.20313,-4.44922 1.01172,-7.68359 2.83203,-9.70703 z m -109.59765,28.3086 h 4.24609 c 1.01172,0 1.41406,-0.40235 1.41406,-1.41407 v -25.27734 c 0,-3.4375 -0.80859,-6.06641 -2.6289,-7.88281 -1.81641,-1.82032 -4.2461,-2.83203 -7.6836,-2.83203 -4.64844,0 -9.5039,1.61718 -14.15234,5.05468 -1.61719,-3.4375 -4.65235,-5.05468 -9.10156,-5.05468 -4.44922,0 -8.89454,1.61718 -13.34375,4.64843 l -0.40625,-2.22265 c 0,-0.60547 -0.20313,-0.8086 -0.60547,-1.01172 -0.20313,-0.20313 -0.60547,-0.20313 -1.01172,-0.20313 h -3.23438 c -1.01172,0 -1.41797,0.40625 -1.41797,1.41797 v 33.56641 c 0,1.01172 0.40625,1.41406 1.41797,1.41406 h 4.2461 c 1.01172,0 1.41406,-0.40234 1.41406,-1.41406 v -27.30078 c 3.4375,-2.01953 6.875,-3.23438 10.51562,-3.23438 2.02344,0 3.4375,0.60547 4.2461,1.82031 0.80859,1.21485 1.41797,2.83204 1.41797,5.25782 v 23.2539 c 0,1.01172 0.40234,1.41407 1.41406,1.41407 h 4.24609 c 1.01172,0 1.41407,-0.40235 1.41407,-1.41407 v -26.08593 c 0,-0.40235 0,-0.8086 0,-1.01172 3.64062,-2.22266 7.07812,-3.23438 10.51562,-3.23438 2.02344,0 3.4375,0.60547 4.24609,1.82031 0.8086,1.21485 1.41797,2.83204 1.41797,5.25782 v 23.2539 c 0,1.01172 0.40235,1.41407 1.41407,1.41407 z m 38.42187,-34.98047 v 26.89453 c -3.44141,2.22265 -6.87891,3.4375 -10.31641,3.4375 -2.22265,0 -3.83984,-0.60938 -4.85156,-1.82031 -1.01172,-1.21485 -1.41406,-3.03516 -1.41406,-5.66407 v -22.84765 c 0,-1.01172 -0.40625,-1.41407 -1.41797,-1.41407 h -4.24609 c -1.01172,0 -1.41407,0.40235 -1.41407,1.41407 v 25.07422 c 0,3.4375 0.8086,6.26953 2.62891,8.08984 1.82031,1.81641 4.44922,2.82812 7.88672,2.82812 4.64844,0 9.30078,-1.61718 13.75,-4.85156 l 0.40234,2.42578 c 0,0.60547 0.20313,0.8086 0.60938,1.01172 0.20312,0.20313 0.60547,0.20313 1.21094,0.20313 h 3.03515 c 1.01172,0 1.41406,-0.40625 1.41406,-1.41797 v -33.36328 c 0,-1.01172 -0.40234,-1.41407 -1.41406,-1.41407 h -4.24609 c -1.21485,0 -1.61719,0.60547 -1.61719,1.41407",
  id: "path4333",
  "inkscapeConnector-curvature": 0
}));

var _ref7 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clip4"
}, /*#__PURE__*/React.createElement("path", {
  d: "m 216,408 h 180 v 41 H 216 Z m 0,0",
  id: "path4573",
  "inkscapeConnector-curvature": 0
}));

var _ref8 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clip5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m 384.17187,440.6875 c 10.51172,-8.89844 13.34375,-27.29688 11.1211,-30.12891 -1.01172,-1.21093 -5.86328,-2.42578 -11.9336,-2.42578 -6.46875,0 -14.15234,1.41406 -20.01562,5.46094 -1.82031,1.21094 -1.41797,2.82812 0.40234,2.62891 6.26953,-0.8125 20.42578,-2.42579 23.05469,0.80859 2.42578,3.23437 -2.83203,16.57812 -5.25781,22.44531 -0.60938,1.82031 0.80859,2.42578 2.6289,1.21094 z m -8.49609,-19.00781 c -22.03906,9.30468 -46.10156,13.95312 -67.94141,13.95312 -32.35156,0 -63.69531,-8.89844 -88.97265,-23.65625 -0.40625,-0.20312 -0.8086,-0.40625 -1.21485,-0.40625 -1.41406,0 -2.22265,1.61719 -0.80859,3.03516 23.45703,21.23047 54.59766,33.96875 88.97266,33.96875 24.67187,0 53.18359,-7.6836 72.79687,-22.24219 3.4375,-2.42578 0.60547,-6.06641 -2.83203,-4.65234 z m 0,0",
  id: "path4576",
  "inkscapeConnector-curvature": 0
}));

var _ref9 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clip6"
}, /*#__PURE__*/React.createElement("path", {
  d: "m 384.17187,440.6875 c 10.51172,-8.89844 13.34375,-27.29688 11.1211,-30.12891 -1.01172,-1.21093 -5.86328,-2.42578 -11.9336,-2.42578 -6.46875,0 -14.15234,1.41406 -20.01562,5.46094 -1.82031,1.21094 -1.41797,2.82812 0.40234,2.62891 6.26953,-0.8125 20.42578,-2.42579 23.05469,0.80859 2.42578,3.23437 -2.83203,16.57812 -5.25781,22.44531 -0.60938,1.82031 0.80859,2.42578 2.6289,1.21094 z m -8.49609,-19.00781 c -22.03906,9.30468 -46.10156,13.95312 -67.94141,13.95312 -32.35156,0 -63.69531,-8.89844 -88.97265,-23.65625 -0.40625,-0.20312 -0.8086,-0.40625 -1.21485,-0.40625 -1.41406,0 -2.22265,1.61719 -0.80859,3.03516 23.45703,21.23047 54.59766,33.96875 88.97266,33.96875 24.67187,0 53.18359,-7.6836 72.79687,-22.24219 3.4375,-2.42578 0.60547,-6.06641 -2.83203,-4.65234",
  id: "path4579",
  "inkscapeConnector-curvature": 0
}));

function SvgAmazonMusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsVvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    width: "180pt",
    height: "105.14844pt",
    viewBox: "0 0 180 105.14844",
    id: "svg4830",
    sodipodiDocname: "amazon-music.svg",
    inkscapeVersion: "0.92.5 (2060ec1f9f, 2020-04-08)",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("defs", {
    id: "defs4811"
  }, _ref4, _ref5, _ref6, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 217.548,
    y1: 422.28699,
    x2: 391.854,
    y2: 422.28699,
    gradientTransform: "matrix(1,0,0,-1,0,792)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(4.705811%,41.960144%,70.195007%)",
      stopOpacity: 1
    },
    id: "stop4336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    style: {
      stopColor: "rgb(4.795837%,42.086792%,70.278931%)",
      stopOpacity: 1
    },
    id: "stop4338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    style: {
      stopColor: "rgb(4.975891%,42.341614%,70.448303%)",
      stopOpacity: 1
    },
    id: "stop4340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    style: {
      stopColor: "rgb(5.155945%,42.59491%,70.619202%)",
      stopOpacity: 1
    },
    id: "stop4342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    style: {
      stopColor: "rgb(5.335999%,42.849731%,70.788574%)",
      stopOpacity: 1
    },
    id: "stop4344"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    style: {
      stopColor: "rgb(5.516052%,43.104553%,70.957947%)",
      stopOpacity: 1
    },
    id: "stop4346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    style: {
      stopColor: "rgb(5.696106%,43.357849%,71.127319%)",
      stopOpacity: 1
    },
    id: "stop4348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    style: {
      stopColor: "rgb(5.87616%,43.612671%,71.296692%)",
      stopOpacity: 1
    },
    id: "stop4350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    style: {
      stopColor: "rgb(6.056213%,43.867493%,71.466064%)",
      stopOpacity: 1
    },
    id: "stop4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    style: {
      stopColor: "rgb(6.236267%,44.120789%,71.635437%)",
      stopOpacity: 1
    },
    id: "stop4354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    style: {
      stopColor: "rgb(6.416321%,44.37561%,71.80481%)",
      stopOpacity: 1
    },
    id: "stop4356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    style: {
      stopColor: "rgb(6.596375%,44.630432%,71.975708%)",
      stopOpacity: 1
    },
    id: "stop4358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    style: {
      stopColor: "rgb(6.776428%,44.885254%,72.145081%)",
      stopOpacity: 1
    },
    id: "stop4360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101563,
    style: {
      stopColor: "rgb(6.956482%,45.13855%,72.314453%)",
      stopOpacity: 1
    },
    id: "stop4362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    style: {
      stopColor: "rgb(7.138062%,45.393372%,72.483826%)",
      stopOpacity: 1
    },
    id: "stop4364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    style: {
      stopColor: "rgb(7.318115%,45.648193%,72.653198%)",
      stopOpacity: 1
    },
    id: "stop4366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    style: {
      stopColor: "rgb(7.498169%,45.901489%,72.822571%)",
      stopOpacity: 1
    },
    id: "stop4368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    style: {
      stopColor: "rgb(7.678223%,46.156311%,72.991943%)",
      stopOpacity: 1
    },
    id: "stop4370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    style: {
      stopColor: "rgb(7.858276%,46.411133%,73.162842%)",
      stopOpacity: 1
    },
    id: "stop4372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    style: {
      stopColor: "rgb(8.03833%,46.665955%,73.332214%)",
      stopOpacity: 1
    },
    id: "stop4374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    style: {
      stopColor: "rgb(8.218384%,46.91925%,73.501587%)",
      stopOpacity: 1
    },
    id: "stop4376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164063,
    style: {
      stopColor: "rgb(8.398438%,47.174072%,73.670959%)",
      stopOpacity: 1
    },
    id: "stop4378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    style: {
      stopColor: "rgb(8.578491%,47.428894%,73.840332%)",
      stopOpacity: 1
    },
    id: "stop4380"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179687,
    style: {
      stopColor: "rgb(8.758545%,47.68219%,74.009705%)",
      stopOpacity: 1
    },
    id: "stop4382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    style: {
      stopColor: "rgb(8.938599%,47.937012%,74.179077%)",
      stopOpacity: 1
    },
    id: "stop4384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195313,
    style: {
      stopColor: "rgb(9.118652%,48.191833%,74.349976%)",
      stopOpacity: 1
    },
    id: "stop4386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    style: {
      stopColor: "rgb(9.300232%,48.445129%,74.519348%)",
      stopOpacity: 1
    },
    id: "stop4388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    style: {
      stopColor: "rgb(9.480286%,48.699951%,74.688721%)",
      stopOpacity: 1
    },
    id: "stop4390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    style: {
      stopColor: "rgb(9.660339%,48.954773%,74.858093%)",
      stopOpacity: 1
    },
    id: "stop4392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    style: {
      stopColor: "rgb(9.840393%,49.209595%,75.027466%)",
      stopOpacity: 1
    },
    id: "stop4394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    style: {
      stopColor: "rgb(10.020447%,49.462891%,75.196838%)",
      stopOpacity: 1
    },
    id: "stop4396"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    style: {
      stopColor: "rgb(10.2005%,49.717712%,75.366211%)",
      stopOpacity: 1
    },
    id: "stop4398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "rgb(10.380554%,49.972534%,75.537109%)",
      stopOpacity: 1
    },
    id: "stop4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    style: {
      stopColor: "rgb(10.560608%,50.22583%,75.706482%)",
      stopOpacity: 1
    },
    id: "stop4402"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    style: {
      stopColor: "rgb(10.740662%,50.480652%,75.875854%)",
      stopOpacity: 1
    },
    id: "stop4404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    style: {
      stopColor: "rgb(10.920715%,50.735474%,76.045227%)",
      stopOpacity: 1
    },
    id: "stop4406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    style: {
      stopColor: "rgb(11.100769%,50.990295%,76.2146%)",
      stopOpacity: 1
    },
    id: "stop4408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    style: {
      stopColor: "rgb(11.280823%,51.243591%,76.383972%)",
      stopOpacity: 1
    },
    id: "stop4410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    style: {
      stopColor: "rgb(11.488342%,51.524353%,76.580811%)",
      stopOpacity: 1
    },
    id: "stop4412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    style: {
      stopColor: "rgb(11.723328%,51.829529%,76.805115%)",
      stopOpacity: 1
    },
    id: "stop4414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    style: {
      stopColor: "rgb(11.956787%,52.134705%,77.029419%)",
      stopOpacity: 1
    },
    id: "stop4416"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    style: {
      stopColor: "rgb(12.191772%,52.441406%,77.253723%)",
      stopOpacity: 1
    },
    id: "stop4418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    style: {
      stopColor: "rgb(12.425232%,52.746582%,77.478027%)",
      stopOpacity: 1
    },
    id: "stop4420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    style: {
      stopColor: "rgb(12.660217%,53.051758%,77.700806%)",
      stopOpacity: 1
    },
    id: "stop4422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    style: {
      stopColor: "rgb(12.893677%,53.356934%,77.92511%)",
      stopOpacity: 1
    },
    id: "stop4424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    style: {
      stopColor: "rgb(13.128662%,53.663635%,78.149414%)",
      stopOpacity: 1
    },
    id: "stop4426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    style: {
      stopColor: "rgb(13.362122%,53.968811%,78.373718%)",
      stopOpacity: 1
    },
    id: "stop4428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    style: {
      stopColor: "rgb(13.597107%,54.273987%,78.598022%)",
      stopOpacity: 1
    },
    id: "stop4430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    style: {
      stopColor: "rgb(13.830566%,54.580688%,78.822327%)",
      stopOpacity: 1
    },
    id: "stop4432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    style: {
      stopColor: "rgb(14.065552%,54.885864%,79.046631%)",
      stopOpacity: 1
    },
    id: "stop4434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    style: {
      stopColor: "rgb(14.299011%,55.19104%,79.270935%)",
      stopOpacity: 1
    },
    id: "stop4436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    style: {
      stopColor: "rgb(14.533997%,55.496216%,79.493713%)",
      stopOpacity: 1
    },
    id: "stop4438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    style: {
      stopColor: "rgb(14.768982%,55.802917%,79.718018%)",
      stopOpacity: 1
    },
    id: "stop4440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    style: {
      stopColor: "rgb(15.002441%,56.108093%,79.942322%)",
      stopOpacity: 1
    },
    id: "stop4442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    style: {
      stopColor: "rgb(15.237427%,56.413269%,80.166626%)",
      stopOpacity: 1
    },
    id: "stop4444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    style: {
      stopColor: "rgb(15.470886%,56.718445%,80.39093%)",
      stopOpacity: 1
    },
    id: "stop4446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    style: {
      stopColor: "rgb(15.705872%,57.025146%,80.615234%)",
      stopOpacity: 1
    },
    id: "stop4448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    style: {
      stopColor: "rgb(15.939331%,57.330322%,80.839539%)",
      stopOpacity: 1
    },
    id: "stop4450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    style: {
      stopColor: "rgb(16.174316%,57.635498%,81.062317%)",
      stopOpacity: 1
    },
    id: "stop4452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    style: {
      stopColor: "rgb(16.407776%,57.940674%,81.286621%)",
      stopOpacity: 1
    },
    id: "stop4454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    style: {
      stopColor: "rgb(16.642761%,58.247375%,81.510925%)",
      stopOpacity: 1
    },
    id: "stop4456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    style: {
      stopColor: "rgb(16.876221%,58.552551%,81.735229%)",
      stopOpacity: 1
    },
    id: "stop4458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    style: {
      stopColor: "rgb(17.111206%,58.857727%,81.959534%)",
      stopOpacity: 1
    },
    id: "stop4460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    style: {
      stopColor: "rgb(17.344666%,59.162903%,82.183838%)",
      stopOpacity: 1
    },
    id: "stop4462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "rgb(17.579651%,59.469604%,82.408142%)",
      stopOpacity: 1
    },
    id: "stop4464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507813,
    style: {
      stopColor: "rgb(17.814636%,59.77478%,82.63092%)",
      stopOpacity: 1
    },
    id: "stop4466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    style: {
      stopColor: "rgb(18.048096%,60.079956%,82.855225%)",
      stopOpacity: 1
    },
    id: "stop4468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    style: {
      stopColor: "rgb(18.283081%,60.386658%,83.079529%)",
      stopOpacity: 1
    },
    id: "stop4470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    style: {
      stopColor: "rgb(18.516541%,60.691833%,83.303833%)",
      stopOpacity: 1
    },
    id: "stop4472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    style: {
      stopColor: "rgb(18.751526%,60.997009%,83.528137%)",
      stopOpacity: 1
    },
    id: "stop4474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    style: {
      stopColor: "rgb(18.984985%,61.302185%,83.752441%)",
      stopOpacity: 1
    },
    id: "stop4476"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    style: {
      stopColor: "rgb(19.219971%,61.608887%,83.976746%)",
      stopOpacity: 1
    },
    id: "stop4478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    style: {
      stopColor: "rgb(19.45343%,61.914063%,84.199524%)",
      stopOpacity: 1
    },
    id: "stop4480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570313,
    style: {
      stopColor: "rgb(19.688416%,62.219238%,84.423828%)",
      stopOpacity: 1
    },
    id: "stop4482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    style: {
      stopColor: "rgb(19.921875%,62.524414%,84.648132%)",
      stopOpacity: 1
    },
    id: "stop4484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    style: {
      stopColor: "rgb(20.15686%,62.831116%,84.872437%)",
      stopOpacity: 1
    },
    id: "stop4486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    style: {
      stopColor: "rgb(20.39032%,63.136292%,85.096741%)",
      stopOpacity: 1
    },
    id: "stop4488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601563,
    style: {
      stopColor: "rgb(20.625305%,63.441467%,85.321045%)",
      stopOpacity: 1
    },
    id: "stop4490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    style: {
      stopColor: "rgb(20.858765%,63.746643%,85.545349%)",
      stopOpacity: 1
    },
    id: "stop4492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    style: {
      stopColor: "rgb(21.09375%,64.053345%,85.768127%)",
      stopOpacity: 1
    },
    id: "stop4494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    style: {
      stopColor: "rgb(21.328735%,64.358521%,85.992432%)",
      stopOpacity: 1
    },
    id: "stop4496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632813,
    style: {
      stopColor: "rgb(21.562195%,64.663696%,86.216736%)",
      stopOpacity: 1
    },
    id: "stop4498"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    style: {
      stopColor: "rgb(21.79718%,64.970398%,86.44104%)",
      stopOpacity: 1
    },
    id: "stop4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    style: {
      stopColor: "rgb(22.03064%,65.275574%,86.665344%)",
      stopOpacity: 1
    },
    id: "stop4502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    style: {
      stopColor: "rgb(22.265625%,65.58075%,86.889648%)",
      stopOpacity: 1
    },
    id: "stop4504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664063,
    style: {
      stopColor: "rgb(22.499084%,65.885925%,87.113953%)",
      stopOpacity: 1
    },
    id: "stop4506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    style: {
      stopColor: "rgb(22.73407%,66.192627%,87.336731%)",
      stopOpacity: 1
    },
    id: "stop4508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    style: {
      stopColor: "rgb(22.967529%,66.497803%,87.561035%)",
      stopOpacity: 1
    },
    id: "stop4510"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    style: {
      stopColor: "rgb(23.202515%,66.802979%,87.785339%)",
      stopOpacity: 1
    },
    id: "stop4512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    style: {
      stopColor: "rgb(23.435974%,67.108154%,88.009644%)",
      stopOpacity: 1
    },
    id: "stop4514"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    style: {
      stopColor: "rgb(23.670959%,67.414856%,88.233948%)",
      stopOpacity: 1
    },
    id: "stop4516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    style: {
      stopColor: "rgb(23.904419%,67.720032%,88.458252%)",
      stopOpacity: 1
    },
    id: "stop4518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    style: {
      stopColor: "rgb(24.139404%,68.025208%,88.682556%)",
      stopOpacity: 1
    },
    id: "stop4520"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726563,
    style: {
      stopColor: "rgb(24.37439%,68.330383%,88.905334%)",
      stopOpacity: 1
    },
    id: "stop4522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    style: {
      stopColor: "rgb(24.607849%,68.637085%,89.129639%)",
      stopOpacity: 1
    },
    id: "stop4524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    style: {
      stopColor: "rgb(24.842834%,68.942261%,89.353943%)",
      stopOpacity: 1
    },
    id: "stop4526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "rgb(25.076294%,69.247437%,89.578247%)",
      stopOpacity: 1
    },
    id: "stop4528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    style: {
      stopColor: "rgb(25.311279%,69.552612%,89.802551%)",
      stopOpacity: 1
    },
    id: "stop4530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    style: {
      stopColor: "rgb(25.544739%,69.859314%,90.026855%)",
      stopOpacity: 1
    },
    id: "stop4532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    style: {
      stopColor: "rgb(25.779724%,70.16449%,90.25116%)",
      stopOpacity: 1
    },
    id: "stop4534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    style: {
      stopColor: "rgb(26.013184%,70.469666%,90.475464%)",
      stopOpacity: 1
    },
    id: "stop4536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    style: {
      stopColor: "rgb(26.248169%,70.776367%,90.698242%)",
      stopOpacity: 1
    },
    id: "stop4538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    style: {
      stopColor: "rgb(26.481628%,71.081543%,90.922546%)",
      stopOpacity: 1
    },
    id: "stop4540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    style: {
      stopColor: "rgb(26.716614%,71.386719%,91.146851%)",
      stopOpacity: 1
    },
    id: "stop4542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    style: {
      stopColor: "rgb(26.950073%,71.691895%,91.371155%)",
      stopOpacity: 1
    },
    id: "stop4544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    style: {
      stopColor: "rgb(27.185059%,71.998596%,91.595459%)",
      stopOpacity: 1
    },
    id: "stop4546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    style: {
      stopColor: "rgb(27.418518%,72.303772%,91.819763%)",
      stopOpacity: 1
    },
    id: "stop4548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    style: {
      stopColor: "rgb(27.653503%,72.608948%,92.044067%)",
      stopOpacity: 1
    },
    id: "stop4550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    style: {
      stopColor: "rgb(27.888489%,72.914124%,92.266846%)",
      stopOpacity: 1
    },
    id: "stop4552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851563,
    style: {
      stopColor: "rgb(28.121948%,73.220825%,92.49115%)",
      stopOpacity: 1
    },
    id: "stop4554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    style: {
      stopColor: "rgb(28.356934%,73.526001%,92.715454%)",
      stopOpacity: 1
    },
    id: "stop4556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    style: {
      stopColor: "rgb(28.590393%,73.831177%,92.939758%)",
      stopOpacity: 1
    },
    id: "stop4558"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    style: {
      stopColor: "rgb(28.825378%,74.136353%,93.164063%)",
      stopOpacity: 1
    },
    id: "stop4560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882813,
    style: {
      stopColor: "rgb(29.058838%,74.443054%,93.388367%)",
      stopOpacity: 1
    },
    id: "stop4562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    style: {
      stopColor: "rgb(29.293823%,74.74823%,93.612671%)",
      stopOpacity: 1
    },
    id: "stop4564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    style: {
      stopColor: "rgb(29.411316%,74.900818%,93.72406%)",
      stopOpacity: 1
    },
    id: "stop4566"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    style: {
      stopColor: "rgb(29.411316%,74.900818%,93.72406%)",
      stopOpacity: 1
    },
    id: "stop4568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(29.411316%,74.900818%,93.72406%)",
      stopOpacity: 1
    },
    id: "stop4570"
  })), _ref7, _ref8, _ref9, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 215.32401,
    y1: 363.646,
    x2: 397.51599,
    y2: 363.646,
    gradientTransform: "matrix(1,0,0,-1,0,792)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(4.705811%,41.960144%,70.195007%)",
      stopOpacity: 1
    },
    id: "stop4582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    style: {
      stopColor: "rgb(4.753113%,42.027283%,70.239258%)",
      stopOpacity: 1
    },
    id: "stop4584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    style: {
      stopColor: "rgb(4.891968%,42.224121%,70.370483%)",
      stopOpacity: 1
    },
    id: "stop4586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    style: {
      stopColor: "rgb(5.073547%,42.480469%,70.542908%)",
      stopOpacity: 1
    },
    id: "stop4588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    style: {
      stopColor: "rgb(5.256653%,42.738342%,70.713806%)",
      stopOpacity: 1
    },
    id: "stop4590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    style: {
      stopColor: "rgb(5.438232%,42.996216%,70.88623%)",
      stopOpacity: 1
    },
    id: "stop4592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    style: {
      stopColor: "rgb(5.621338%,43.252563%,71.057129%)",
      stopOpacity: 1
    },
    id: "stop4594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    style: {
      stopColor: "rgb(5.802917%,43.510437%,71.229553%)",
      stopOpacity: 1
    },
    id: "stop4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    style: {
      stopColor: "rgb(5.986023%,43.768311%,71.400452%)",
      stopOpacity: 1
    },
    id: "stop4598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    style: {
      stopColor: "rgb(6.167603%,44.026184%,71.572876%)",
      stopOpacity: 1
    },
    id: "stop4600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    style: {
      stopColor: "rgb(6.350708%,44.282532%,71.743774%)",
      stopOpacity: 1
    },
    id: "stop4602"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    style: {
      stopColor: "rgb(6.533813%,44.540405%,71.916199%)",
      stopOpacity: 1
    },
    id: "stop4604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    style: {
      stopColor: "rgb(6.715393%,44.798279%,72.087097%)",
      stopOpacity: 1
    },
    id: "stop4606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    style: {
      stopColor: "rgb(6.898499%,45.056152%,72.259521%)",
      stopOpacity: 1
    },
    id: "stop4608"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    style: {
      stopColor: "rgb(7.080078%,45.3125%,72.43042%)",
      stopOpacity: 1
    },
    id: "stop4610"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    style: {
      stopColor: "rgb(7.263184%,45.570374%,72.602844%)",
      stopOpacity: 1
    },
    id: "stop4612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    style: {
      stopColor: "rgb(7.444763%,45.828247%,72.773743%)",
      stopOpacity: 1
    },
    id: "stop4614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132813,
    style: {
      stopColor: "rgb(7.627869%,46.086121%,72.946167%)",
      stopOpacity: 1
    },
    id: "stop4616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    style: {
      stopColor: "rgb(7.809448%,46.342468%,73.117065%)",
      stopOpacity: 1
    },
    id: "stop4618"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    style: {
      stopColor: "rgb(7.992554%,46.600342%,73.28949%)",
      stopOpacity: 1
    },
    id: "stop4620"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    style: {
      stopColor: "rgb(8.174133%,46.858215%,73.460388%)",
      stopOpacity: 1
    },
    id: "stop4622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    style: {
      stopColor: "rgb(8.357239%,47.114563%,73.632813%)",
      stopOpacity: 1
    },
    id: "stop4624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    style: {
      stopColor: "rgb(8.538818%,47.372437%,73.803711%)",
      stopOpacity: 1
    },
    id: "stop4626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    style: {
      stopColor: "rgb(8.721924%,47.63031%,73.976135%)",
      stopOpacity: 1
    },
    id: "stop4628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    style: {
      stopColor: "rgb(8.903503%,47.888184%,74.147034%)",
      stopOpacity: 1
    },
    id: "stop4630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    style: {
      stopColor: "rgb(9.086609%,48.144531%,74.319458%)",
      stopOpacity: 1
    },
    id: "stop4632"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    style: {
      stopColor: "rgb(9.268188%,48.402405%,74.490356%)",
      stopOpacity: 1
    },
    id: "stop4634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    style: {
      stopColor: "rgb(9.451294%,48.660278%,74.662781%)",
      stopOpacity: 1
    },
    id: "stop4636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    style: {
      stopColor: "rgb(9.632874%,48.918152%,74.833679%)",
      stopOpacity: 1
    },
    id: "stop4638"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    style: {
      stopColor: "rgb(9.815979%,49.1745%,75.004578%)",
      stopOpacity: 1
    },
    id: "stop4640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    style: {
      stopColor: "rgb(9.997559%,49.432373%,75.177002%)",
      stopOpacity: 1
    },
    id: "stop4642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242187,
    style: {
      stopColor: "rgb(10.180664%,49.690247%,75.3479%)",
      stopOpacity: 1
    },
    id: "stop4644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "rgb(10.362244%,49.94812%,75.520325%)",
      stopOpacity: 1
    },
    id: "stop4646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    style: {
      stopColor: "rgb(10.545349%,50.204468%,75.691223%)",
      stopOpacity: 1
    },
    id: "stop4648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    style: {
      stopColor: "rgb(10.726929%,50.462341%,75.863647%)",
      stopOpacity: 1
    },
    id: "stop4650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273437,
    style: {
      stopColor: "rgb(10.910034%,50.720215%,76.034546%)",
      stopOpacity: 1
    },
    id: "stop4652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    style: {
      stopColor: "rgb(11.09314%,50.978088%,76.20697%)",
      stopOpacity: 1
    },
    id: "stop4654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    style: {
      stopColor: "rgb(11.274719%,51.234436%,76.377869%)",
      stopOpacity: 1
    },
    id: "stop4656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    style: {
      stopColor: "rgb(11.483765%,51.51825%,76.576233%)",
      stopOpacity: 1
    },
    id: "stop4658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    style: {
      stopColor: "rgb(11.720276%,51.826477%,76.802063%)",
      stopOpacity: 1
    },
    id: "stop4660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    style: {
      stopColor: "rgb(11.956787%,52.134705%,77.029419%)",
      stopOpacity: 1
    },
    id: "stop4662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    style: {
      stopColor: "rgb(12.194824%,52.444458%,77.256775%)",
      stopOpacity: 1
    },
    id: "stop4664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    style: {
      stopColor: "rgb(12.431335%,52.754211%,77.482605%)",
      stopOpacity: 1
    },
    id: "stop4666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    style: {
      stopColor: "rgb(12.667847%,53.062439%,77.709961%)",
      stopOpacity: 1
    },
    id: "stop4668"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    style: {
      stopColor: "rgb(12.905884%,53.372192%,77.937317%)",
      stopOpacity: 1
    },
    id: "stop4670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    style: {
      stopColor: "rgb(13.142395%,53.681946%,78.163147%)",
      stopOpacity: 1
    },
    id: "stop4672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    style: {
      stopColor: "rgb(13.380432%,53.991699%,78.390503%)",
      stopOpacity: 1
    },
    id: "stop4674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    style: {
      stopColor: "rgb(13.616943%,54.299927%,78.617859%)",
      stopOpacity: 1
    },
    id: "stop4676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    style: {
      stopColor: "rgb(13.853455%,54.60968%,78.843689%)",
      stopOpacity: 1
    },
    id: "stop4678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    style: {
      stopColor: "rgb(14.091492%,54.919434%,79.071045%)",
      stopOpacity: 1
    },
    id: "stop4680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    style: {
      stopColor: "rgb(14.328003%,55.227661%,79.298401%)",
      stopOpacity: 1
    },
    id: "stop4682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    style: {
      stopColor: "rgb(14.56604%,55.537415%,79.524231%)",
      stopOpacity: 1
    },
    id: "stop4684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    style: {
      stopColor: "rgb(14.802551%,55.847168%,79.751587%)",
      stopOpacity: 1
    },
    id: "stop4686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    style: {
      stopColor: "rgb(15.039063%,56.155396%,79.978943%)",
      stopOpacity: 1
    },
    id: "stop4688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    style: {
      stopColor: "rgb(15.2771%,56.465149%,80.204773%)",
      stopOpacity: 1
    },
    id: "stop4690"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    style: {
      stopColor: "rgb(15.513611%,56.774902%,80.432129%)",
      stopOpacity: 1
    },
    id: "stop4692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    style: {
      stopColor: "rgb(15.751648%,57.084656%,80.657959%)",
      stopOpacity: 1
    },
    id: "stop4694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    style: {
      stopColor: "rgb(15.988159%,57.392883%,80.885315%)",
      stopOpacity: 1
    },
    id: "stop4696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    style: {
      stopColor: "rgb(16.22467%,57.702637%,81.112671%)",
      stopOpacity: 1
    },
    id: "stop4698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    style: {
      stopColor: "rgb(16.462708%,58.01239%,81.338501%)",
      stopOpacity: 1
    },
    id: "stop4700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    style: {
      stopColor: "rgb(16.699219%,58.320618%,81.565857%)",
      stopOpacity: 1
    },
    id: "stop4702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    style: {
      stopColor: "rgb(16.937256%,58.630371%,81.793213%)",
      stopOpacity: 1
    },
    id: "stop4704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    style: {
      stopColor: "rgb(17.173767%,58.940125%,82.019043%)",
      stopOpacity: 1
    },
    id: "stop4706"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492187,
    style: {
      stopColor: "rgb(17.410278%,59.249878%,82.246399%)",
      stopOpacity: 1
    },
    id: "stop4708"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "rgb(17.648315%,59.558105%,82.473755%)",
      stopOpacity: 1
    },
    id: "stop4710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507813,
    style: {
      stopColor: "rgb(17.884827%,59.867859%,82.699585%)",
      stopOpacity: 1
    },
    id: "stop4712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    style: {
      stopColor: "rgb(18.122864%,60.177612%,82.926941%)",
      stopOpacity: 1
    },
    id: "stop4714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    style: {
      stopColor: "rgb(18.359375%,60.48584%,83.154297%)",
      stopOpacity: 1
    },
    id: "stop4716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    style: {
      stopColor: "rgb(18.597412%,60.795593%,83.380127%)",
      stopOpacity: 1
    },
    id: "stop4718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    style: {
      stopColor: "rgb(18.833923%,61.105347%,83.607483%)",
      stopOpacity: 1
    },
    id: "stop4720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    style: {
      stopColor: "rgb(19.070435%,61.413574%,83.834839%)",
      stopOpacity: 1
    },
    id: "stop4722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554687,
    style: {
      stopColor: "rgb(19.308472%,61.723328%,84.060669%)",
      stopOpacity: 1
    },
    id: "stop4724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    style: {
      stopColor: "rgb(19.544983%,62.033081%,84.288025%)",
      stopOpacity: 1
    },
    id: "stop4726"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570313,
    style: {
      stopColor: "rgb(19.78302%,62.342834%,84.515381%)",
      stopOpacity: 1
    },
    id: "stop4728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    style: {
      stopColor: "rgb(20.019531%,62.651062%,84.741211%)",
      stopOpacity: 1
    },
    id: "stop4730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    style: {
      stopColor: "rgb(20.256042%,62.960815%,84.968567%)",
      stopOpacity: 1
    },
    id: "stop4732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    style: {
      stopColor: "rgb(20.49408%,63.270569%,85.194397%)",
      stopOpacity: 1
    },
    id: "stop4734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    style: {
      stopColor: "rgb(20.730591%,63.578796%,85.421753%)",
      stopOpacity: 1
    },
    id: "stop4736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    style: {
      stopColor: "rgb(20.968628%,63.88855%,85.649109%)",
      stopOpacity: 1
    },
    id: "stop4738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617187,
    style: {
      stopColor: "rgb(21.205139%,64.198303%,85.874939%)",
      stopOpacity: 1
    },
    id: "stop4740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    style: {
      stopColor: "rgb(21.44165%,64.506531%,86.102295%)",
      stopOpacity: 1
    },
    id: "stop4742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    style: {
      stopColor: "rgb(21.679688%,64.816284%,86.329651%)",
      stopOpacity: 1
    },
    id: "stop4744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    style: {
      stopColor: "rgb(21.916199%,65.126038%,86.555481%)",
      stopOpacity: 1
    },
    id: "stop4746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    style: {
      stopColor: "rgb(22.154236%,65.435791%,86.782837%)",
      stopOpacity: 1
    },
    id: "stop4748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    style: {
      stopColor: "rgb(22.390747%,65.744019%,87.010193%)",
      stopOpacity: 1
    },
    id: "stop4750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664063,
    style: {
      stopColor: "rgb(22.627258%,66.053772%,87.236023%)",
      stopOpacity: 1
    },
    id: "stop4752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    style: {
      stopColor: "rgb(22.865295%,66.363525%,87.463379%)",
      stopOpacity: 1
    },
    id: "stop4754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    style: {
      stopColor: "rgb(23.101807%,66.671753%,87.690735%)",
      stopOpacity: 1
    },
    id: "stop4756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    style: {
      stopColor: "rgb(23.339844%,66.981506%,87.916565%)",
      stopOpacity: 1
    },
    id: "stop4758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    style: {
      stopColor: "rgb(23.576355%,67.29126%,88.143921%)",
      stopOpacity: 1
    },
    id: "stop4760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    style: {
      stopColor: "rgb(23.812866%,67.599487%,88.371277%)",
      stopOpacity: 1
    },
    id: "stop4762"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    style: {
      stopColor: "rgb(24.050903%,67.909241%,88.597107%)",
      stopOpacity: 1
    },
    id: "stop4764"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    style: {
      stopColor: "rgb(24.287415%,68.218994%,88.824463%)",
      stopOpacity: 1
    },
    id: "stop4766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726563,
    style: {
      stopColor: "rgb(24.525452%,68.528748%,89.050293%)",
      stopOpacity: 1
    },
    id: "stop4768"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    style: {
      stopColor: "rgb(24.761963%,68.836975%,89.277649%)",
      stopOpacity: 1
    },
    id: "stop4770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    style: {
      stopColor: "rgb(24.998474%,69.146729%,89.505005%)",
      stopOpacity: 1
    },
    id: "stop4772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "rgb(25.236511%,69.456482%,89.730835%)",
      stopOpacity: 1
    },
    id: "stop4774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    style: {
      stopColor: "rgb(25.473022%,69.764709%,89.958191%)",
      stopOpacity: 1
    },
    id: "stop4776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    style: {
      stopColor: "rgb(25.71106%,70.074463%,90.185547%)",
      stopOpacity: 1
    },
    id: "stop4778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773437,
    style: {
      stopColor: "rgb(25.947571%,70.384216%,90.411377%)",
      stopOpacity: 1
    },
    id: "stop4780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    style: {
      stopColor: "rgb(26.184082%,70.692444%,90.638733%)",
      stopOpacity: 1
    },
    id: "stop4782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    style: {
      stopColor: "rgb(26.422119%,71.002197%,90.866089%)",
      stopOpacity: 1
    },
    id: "stop4784"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    style: {
      stopColor: "rgb(26.65863%,71.311951%,91.091919%)",
      stopOpacity: 1
    },
    id: "stop4786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    style: {
      stopColor: "rgb(26.896667%,71.621704%,91.319275%)",
      stopOpacity: 1
    },
    id: "stop4788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    style: {
      stopColor: "rgb(27.133179%,71.929932%,91.546631%)",
      stopOpacity: 1
    },
    id: "stop4790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    style: {
      stopColor: "rgb(27.36969%,72.239685%,91.772461%)",
      stopOpacity: 1
    },
    id: "stop4792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    style: {
      stopColor: "rgb(27.607727%,72.549438%,91.999817%)",
      stopOpacity: 1
    },
    id: "stop4794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    style: {
      stopColor: "rgb(27.844238%,72.857666%,92.227173%)",
      stopOpacity: 1
    },
    id: "stop4796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    style: {
      stopColor: "rgb(28.082275%,73.167419%,92.453003%)",
      stopOpacity: 1
    },
    id: "stop4798"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851563,
    style: {
      stopColor: "rgb(28.318787%,73.477173%,92.680359%)",
      stopOpacity: 1
    },
    id: "stop4800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    style: {
      stopColor: "rgb(28.556824%,73.7854%,92.906189%)",
      stopOpacity: 1
    },
    id: "stop4802"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    style: {
      stopColor: "rgb(28.793335%,74.095154%,93.133545%)",
      stopOpacity: 1
    },
    id: "stop4804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    style: {
      stopColor: "rgb(29.029846%,74.404907%,93.360901%)",
      stopOpacity: 1
    },
    id: "stop4806"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(29.28009%,74.729919%,93.598938%)",
      stopOpacity: 1
    },
    id: "stop4808"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1",
    transform: "translate(-216,-343.42578)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    id: "g4819",
    style: {
      clipRule: "nonzero"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    id: "g4817",
    style: {
      clipRule: "evenodd"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    id: "g4815",
    style: {
      clipRule: "nonzero"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 217.54687,396 v -52.57422 h 174.3086 V 396 Z m 0,0",
    id: "path4813",
    "inkscapeConnector-curvature": 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)",
    id: "g4827",
    style: {
      clipRule: "nonzero"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)",
    id: "g4825",
    style: {
      clipRule: "evenodd"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)",
    id: "g4823",
    style: {
      clipRule: "nonzero"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 215.32422,448.57422 v -40.44141 h 182.1914 v 40.44141 z m 0,0",
    id: "path4821",
    "inkscapeConnector-curvature": 0
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonMusic);
export default __webpack_public_path__ + "static/media/amazon-music.a1bef400.svg";
export { ForwardRef as ReactComponent };